import "core-js/modules/es.array.sort.js";
import r from "leven";
import e from "ramda/src/pathOr";
import t from "lodash.deburr";
var n, a;
!function (r) {
  r.ALL_CLOSEST_MATCHES = "all-closest-matches", r.ALL_MATCHES = "all-matches", r.ALL_SORTED_MATCHES = "all-sorted-matches", r.FIRST_CLOSEST_MATCH = "first-closest-match", r.FIRST_MATCH = "first-match";
}(n || (n = {})), function (r) {
  r.EDIT_DISTANCE = "edit-distance", r.SIMILARITY = "similarity";
}(a || (a = {}));
var o = new Error("unknown returnType"),
    c = new Error("unknown thresholdType");

function s(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}

function u(r, e) {
  var t = Object.keys(r);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    })), t.push.apply(t, n);
  }

  return t;
}

function i(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = null != arguments[e] ? arguments[e] : {};
    e % 2 ? u(t, !0).forEach(function (e) {
      s(r, e, t[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : u(t).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(t, e));
    });
  }

  return r;
}

var T = function T(r, e) {
  var n = r;
  return e.trimSpaces && (n = n.trim().replace(/\s+/g, " ")), e.deburr && (n = t(n)), e.caseSensitive || (n = n.toLowerCase()), n;
},
    h = function h(r, t) {
  var n = t.matchPath,
      a = Array.isArray(n) && n.length ? e("", n, r) : r;
  return "string" != typeof a ? "" : T(a, t);
};

export default function (e, t, s) {
  var u,
      f,
      S = function (r) {
    var e = i({
      caseSensitive: !1,
      deburr: !1,
      matchPath: [],
      returnType: n.FIRST_CLOSEST_MATCH,
      thresholdType: a.SIMILARITY,
      trimSpaces: !0
    }, r);

    switch (e.thresholdType) {
      case a.EDIT_DISTANCE:
        return i({
          threshold: 20
        }, e);

      case a.SIMILARITY:
        return i({
          threshold: .4
        }, e);

      default:
        throw c;
    }
  }(s),
      l = S.returnType,
      p = S.threshold,
      A = S.thresholdType,
      I = T(e, S);

  switch (A) {
    case a.EDIT_DISTANCE:
      u = function u(r) {
        return r <= p;
      }, f = function f(e) {
        return r(I, h(e, S));
      };
      break;

    case a.SIMILARITY:
      u = function u(r) {
        return r >= p;
      }, f = function f(e) {
        return function (e, t) {
          if (!e || !t) return 0;
          if (e === t) return 1;
          var n = r(e, t),
              a = Math.max(e.length, t.length);
          return (a - n) / a;
        }(I, h(e, S));
      };
      break;

    default:
      throw c;
  }

  var E = [],
      L = t.length;

  switch (l) {
    case n.ALL_CLOSEST_MATCHES:
    case n.FIRST_CLOSEST_MATCH:
      var _,
          b = [];

      switch (A) {
        case a.EDIT_DISTANCE:
          _ = 1 / 0;

          for (var v = 0; v < L; v += 1) {
            var C = f(t[v]);
            _ > C && (_ = C), b.push(C);
          }

          break;

        case a.SIMILARITY:
          _ = 0;

          for (var d = 0; d < L; d += 1) {
            var O = f(t[d]);
            _ < O && (_ = O), b.push(O);
          }

          break;

        default:
          throw c;
      }

      for (var m = b.length, w = 0; w < m; w += 1) {
        var y = b[w];
        u(y) && y === _ && E.push(w);
      }

      break;

    case n.ALL_MATCHES:
      for (var M = 0; M < L; M += 1) {
        u(f(t[M])) && E.push(M);
      }

      break;

    case n.ALL_SORTED_MATCHES:
      for (var g = [], D = 0; D < L; D += 1) {
        var H = f(t[D]);
        u(H) && g.push({
          score: H,
          index: D
        });
      }

      switch (A) {
        case a.EDIT_DISTANCE:
          g.sort(function (r, e) {
            return r.score - e.score;
          });
          break;

        case a.SIMILARITY:
          g.sort(function (r, e) {
            return e.score - r.score;
          });
          break;

        default:
          throw c;
      }

      for (var R = 0, k = g; R < k.length; R++) {
        var P = k[R];
        E.push(P.index);
      }

      break;

    case n.FIRST_MATCH:
      for (var j = 0; j < L; j += 1) {
        if (u(f(t[j]))) {
          E.push(j);
          break;
        }
      }

      break;

    default:
      throw o;
  }

  return function (r, e, t) {
    switch (t) {
      case n.ALL_CLOSEST_MATCHES:
      case n.ALL_MATCHES:
      case n.ALL_SORTED_MATCHES:
        return e.map(function (e) {
          return r[e];
        });

      case n.FIRST_CLOSEST_MATCH:
      case n.FIRST_MATCH:
        return e.length ? r[e[0]] : null;

      default:
        return null;
    }
  }(t, E, l);
}
export { n as ReturnTypeEnums, a as ThresholdTypeEnums };